module.exports = __webpack_public_path__ + "img/icon_phone.87e405c9.png";